import loginByTicket from './loginByTicket.js';

/**
 * Export the Vue plugin install method
 * @param {object} Vue Vue instance
 */
export const install = (Vue) => {
	Vue.prototype.loginByTicket = loginByTicket;
};

export default {
	install
};
